import './styles.scss'
import React from 'react'
import { COFFEE_CAFES } from 'Utils/Constants'
import { getLocalUserDetails } from 'Utils/LocalStorage_Handler'

const CoffeeCafes = () => {
  const userDetails = getLocalUserDetails()

  return (
    <div className={`coffee-cafes-container ${userDetails?.id ? 'logged-in' : 'guest-user'}`}>
      <img className="coffee-cafes-image" src={COFFEE_CAFES.image} alt="Coffee-Cafes" />
    </div>
  )
}

export default CoffeeCafes
